import React from "react";
import {
    Navigate,
} from "react-router-dom";


const TelegramChatsListComponent = React.lazy(() => import("../../../../../components/telegram-conversations/components/list/page"));
const TelegramChatsDetailComponent = React.lazy(() => import("../../../../../components/telegram-conversations/components/detail/page"));

export const telegramChatsRoutes = [
    {
        path: 'list',
        element: <TelegramChatsListComponent />
    },
    {
        path: 'show/:clientId',
        element: <TelegramChatsDetailComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/administration/telegram-chats/list" />
    },
];
